import { facilityStayAction } from '../../actions/constant';

const { SUCCESS_CREATE_FACILITY_STAY, FAILURE_CREATE_FACILITY_STAY, RESET_CREATE_FACILITY_STAY,CREATE_FACILITY_LOADING } =
  facilityStayAction;

const initialState: object = {
  useFacilityStayCreated: false,
  response: null,
  loading:false,
};

export const createFacilityStayReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SUCCESS_CREATE_FACILITY_STAY: {
      return {
        ...state,
        useFacilityStayCreated: true,
        response: action.payload,
        loading:false,
      };
    }

    case FAILURE_CREATE_FACILITY_STAY:
      return {
        ...state,
        useFacilityStayCreated: false,
        response: action.payload,
        loading:false,
      };

      case CREATE_FACILITY_LOADING:
      return {
        ...state,
        loading:true,
      };

    case RESET_CREATE_FACILITY_STAY:
      return initialState;

    default:
      return state;
  }
};
